module.exports = __webpack_public_path__ + "media/images/icons/email-31fb6401b8bf4b251b332fa62cea2cbc.svg";